import Image from 'next/legacy/image';

import KeyImg from '@/common/images/others/key.png';

const Custom404Page = () => {
  return (
    <div className="mt-12 flex items-center justify-center">
      <div className="flex flex-col items-center">
        <Image src={KeyImg} alt="key" />
        <div className="mt-[30px] text-center text-[24px] font-bold text-neutral-800 md:text-[32px]">
          Your HR Buddy Will Be Faster, Better – Soon!
        </div>
        <div className="mt-[10px] text-center text-[18px] md:text-[24px]">
          We commit to help your hiring and branding 10x easier. <br /> More
          features coming your way April 2022.
        </div>
      </div>
    </div>
  );
};

export default Custom404Page;
